/* eslint-disable indent */
import React from "react";
import { Modal } from "../../Shared/Modal/Modal";
import * as styles from "./BVRatingForm.css";
import { BVRatingContainer } from "./BVRatingContainer";
import { BVValidationLabel } from "./BVValidationLabel";
import { BVReviewInput } from "./BVReviewInput";
import { cx } from "emotion";
import { BVTerms } from "./BVTerms";
import axios from "axios";
import PropTypes from "prop-types";
import { BVSuccess } from "./BVSuccess";
import { passKey, bvApiUrl } from "../config";
import { BVReject } from "./BVReject";
import { BVError } from "./BVError";
import 'react-app-polyfill/ie11';

export class BVRatingForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeView: "form",
            activeSection: "",
            showModal: false,
            reviewInputValue: null,
            generalRatingValue: null,
            recommendationInputValue: null,
            titleInputValue: null,
            userNameInputValue: null,
            userNicknameInUse: false,
            ageSelectValue: null,
            genderSelectValue: null,
            productValueInputValue: null,
            productQualityInputValue: null,
            termsCheckboxValue: null
        };
    }

    componentDidMount = () => {
        const showRatingFormButtons = document.getElementsByClassName(
            "bv-show-rating-button"
        );
        if (showRatingFormButtons) {
            Array.from(showRatingFormButtons).map(button =>
                button.addEventListener("click", () =>
                    this.setState({ showModal: true })
                )
            );
        }
        const reviewAdded = localStorage.getItem(
            `reviewAdded-${window.location.pathname}`
        );
        if (reviewAdded) {
            this.setState({
                activeView: "reject"
            });
        }


    };

    handleReviewInputValidation = () => {
        const { reviewInputValue } = this.state;

        return reviewInputValue !== null && reviewInputValue.length >= 50;
    };

    handleRatingStarsValidation = () => {
        const { generalRatingValue } = this.state;

        return generalRatingValue !== null && generalRatingValue > 0;
    };

    handleTitleInputValidation = () => {
        const { titleInputValue } = this.state;

        return titleInputValue !== null && titleInputValue.length > 0;
    };

    handleUserNameValidation = () => {
        const { userNameInputValue } = this.state;

        return userNameInputValue !== null && userNameInputValue.length >= 4;
    };

    handleTermsCheckboxValidation = () => {
        const { termsCheckboxValue } = this.state;

        return termsCheckboxValue !== null && termsCheckboxValue;
    };

    handleAgeSelectValidation = () => {
        const { ageSelectValue } = this.state;

        return ageSelectValue !== null && ageSelectValue !== "invalid";
    };

    handleSubmit = e => {
        e.preventDefault();
        const {
            reviewInputValue,
            generalRatingValue,
            recommendationInputValue,
            titleInputValue,
            userNameInputValue,
            ageSelectValue,
            genderSelectValue,
            productValueInputValue,
            productQualityInputValue,
            termsCheckboxValue
        } = this.state;

        if (
            this.handleRatingStarsValidation() &&
            this.handleReviewInputValidation() &&
            this.handleTitleInputValidation() &&
            this.handleUserNameValidation() &&
            this.handleTermsCheckboxValidation() &&
            this.handleAgeSelectValidation()
        ) {
            /* eslint-disable camelcase */
            const { productId } = this.props;
            axios
                .post(bvApiUrl, null, {
                    method: "post",
                    url: bvApiUrl,
                    withCredentials: false,
                    crossdomain: true,
                    params: {
                        Locale: "ru_RU",
                        PassKey: passKey,
                        ApiVersion: 5.4,
                        Title: titleInputValue,
                        IsRecommended: recommendationInputValue,
                        Rating: generalRatingValue,
                        Rating_Quality: productQualityInputValue,
                        Rating_Value: productValueInputValue,
                        ReviewText: reviewInputValue,
                        UserNickname: userNameInputValue,
                        ContextDataValue_Age: ageSelectValue,
                        AgreedToTermsAndConditions: termsCheckboxValue,
                        ProductId: productId,
                        Action: "Submit"
                    },
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    }
                })
                .then(res => {
                    if (
                        res.data.FormErrors.FieldErrors &&
                        res.data.FormErrors.FieldErrors.usernickname
                    ) {
                        this.setState({
                            userNicknameInUse: true
                        });
                    } else if (res.data.HasErrors) {
                        this.setState({
                            activeView: "error"
                        });
                    } else {
                        this.setState(
                            {
                                activeView: "success"
                            },
                            () =>
                                localStorage.setItem(
                                    `reviewAdded-${window.location.pathname}`,
                                    "1"
                                )
                        );
                    }
                });
            /* eslint-enable camelcase */
        } else {
            this.setState({
                reviewInputValue:
                    reviewInputValue !== null ? reviewInputValue : "",
                generalRatingValue:
                    generalRatingValue !== null ? generalRatingValue : -1,
                recommendationInputValue:
                    recommendationInputValue !== null
                        ? recommendationInputValue
                        : "",
                titleInputValue:
                    titleInputValue !== null ? titleInputValue : "",
                userNameInputValue:
                    userNameInputValue !== null ? userNameInputValue : "",
                ageSelectValue:
                    ageSelectValue !== null ? ageSelectValue : "invalid",
                genderSelectValue:
                    genderSelectValue !== null ? genderSelectValue : "",
                productValueInputValue:
                    productValueInputValue !== null
                        ? productValueInputValue
                        : "",
                productQualityInputValue:
                    productQualityInputValue !== null
                        ? productQualityInputValue
                        : "",
                termsCheckboxValue:
                    termsCheckboxValue !== null ? termsCheckboxValue : false
            });
        }
    };

    render() {
        const {
            activeView,
            activeSection,
            showModal,
            reviewInputValue,
            generalRatingValue,
            recommendationInputValue,
            titleInputValue,
            userNameInputValue,
            userNicknameInUse,
            ageSelectValue,
            genderSelectValue,
            productValueInputValue,
            productQualityInputValue,
            termsCheckboxValue
        } = this.state;
        return (
            <Modal
                className={styles.modalContainer}
                onRequestClose={() =>
                    activeView === "success" || activeView === "error"
                        ? this.setState({
                              showModal: false,
                              activeView:
                                  activeView === "success" ? "reject" : "form",
                              activeSection: "",
                              reviewInputValue: null,
                              generalRatingValue: null,
                              recommendationInputValue: null,
                              titleInputValue: null,
                              userNameInputValue: null,
                              ageSelectValue: null,
                              genderSelectValue: null,
                              productValueInputValue: null,
                              productQualityInputValue: null,
                              termsCheckboxValue: null
                          })
                        : this.setState({
                              showModal: false
                          })
                }
                isOpen={showModal}
                renderModal={() => (
                    <React.Fragment>
                        {activeView === "form" ? (
                            <form type="submit">
                                <div className={styles.ratingContainer}>
                                    <div className={styles.ratingTitleWrapper}>
                                        <div className={styles.ratingTitle}>
                                            Обзор
                                        </div>
                                        <p className={styles.ratingInformation}>
                                            Обязательные поля помечены *
                                        </p>
                                    </div>
                                    <div className={styles.borderLine} />
                                    <div
                                        className={cx(
                                            styles.generalRateFormContainer,
                                            activeSection === "generalRate"
                                                ? styles.activeSection
                                                : ""
                                        )}
                                        onClick={() =>
                                            this.setState({
                                                activeSection: "generalRate"
                                            })
                                        }
                                    >
                                        <div className={styles.sectionWrapper}>
                                            <div className={styles.side}>
                                                <div
                                                    className={
                                                        styles.sectionTitle
                                                    }
                                                >
                                                    Общая оценка*
                                                </div>
                                            </div>
                                            <div
                                                className={cx(
                                                    styles.side,
                                                    styles.rightSide
                                                )}
                                            >
                                                <BVRatingContainer
                                                    selectedStar={
                                                        generalRatingValue
                                                    }
                                                    onSelect={value =>
                                                        this.setState({
                                                            generalRatingValue: value
                                                        })
                                                    }
                                                    className={
                                                        styles.ratingWrapper
                                                    }
                                                />
                                                {generalRatingValue !== null ? (
                                                    <BVValidationLabel
                                                        type={
                                                            this.handleRatingStarsValidation()
                                                                ? ""
                                                                : "danger"
                                                        }
                                                        className={
                                                            styles.validationLabel
                                                        }
                                                    />
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>

                                    <div className={styles.borderLine} />
                                    <div
                                        onClick={() =>
                                            this.setState({
                                                activeSection: "title"
                                            })
                                        }
                                        className={cx(
                                            styles.generalRateFormContainer,
                                            activeSection === "title"
                                                ? styles.activeSection
                                                : ""
                                        )}
                                    >
                                        <div className={styles.titleWrapper}>
                                            <div
                                                className={styles.sectionTitle}
                                            >
                                                Название обзора*
                                            </div>
                                            {titleInputValue !== null ? (
                                                <BVValidationLabel
                                                    type={
                                                        this.handleTitleInputValidation()
                                                            ? ""
                                                            : "danger"
                                                    }
                                                    className={
                                                        styles.validationLabel
                                                    }
                                                />
                                            ) : null}
                                        </div>
                                        <input
                                            maxLength="50"
                                            defaultValue={titleInputValue}
                                            className={cx(
                                                styles.input,
                                                styles.inputCustom
                                            )}
                                            onChange={e =>
                                                this.setState({
                                                    titleInputValue:
                                                        e.target.value
                                                })
                                            }
                                            placeholder="Пример: Отличные функциональные возможности!"
                                        />
                                    </div>
                                    <div className={styles.borderLine} />
                                    <div
                                        className={cx(
                                            styles.generalRateFormContainer,
                                            activeSection === "reviewAndMedia"
                                                ? styles.activeSection
                                                : ""
                                        )}
                                        onClick={() =>
                                            this.setState({
                                                activeSection: "reviewAndMedia"
                                            })
                                        }
                                    >
                                        <div className={styles.titleWrapper}>
                                            <div
                                                className={styles.sectionTitle}
                                            >
                                                Обзор*
                                            </div>
                                            {reviewInputValue !== null ? (
                                                <BVValidationLabel
                                                    type={
                                                        this.handleReviewInputValidation(
                                                            reviewInputValue
                                                        )
                                                            ? ""
                                                            : "danger"
                                                    }
                                                    className={
                                                        styles.validationLabel
                                                    }
                                                    customDangerLabel={`На ${50 -
                                                        reviewInputValue.length} символа короче`}
                                                />
                                            ) : null}
                                        </div>
                                        <BVReviewInput
                                            defaultValue={reviewInputValue}
                                            onChange={value =>
                                                this.setState({
                                                    reviewInputValue: value
                                                })
                                            }
                                            setActiveView={value =>
                                                this.setState({
                                                    activeView: value
                                                })
                                            }
                                        />
                                    </div>
                                    <div className={styles.borderLine} />
                                    <div
                                        onClick={() =>
                                            this.setState({
                                                activeSection: "userName"
                                            })
                                        }
                                        className={cx(
                                            styles.generalRateFormContainer,
                                            activeSection === "userName"
                                                ? styles.activeSection
                                                : ""
                                        )}
                                    >
                                        <div className={styles.titleWrapper}>
                                            <div
                                                className={styles.sectionTitle}
                                            >
                                                Псевдоним*
                                            </div>
                                            {userNameInputValue !== null ? (
                                                <BVValidationLabel
                                                    type={
                                                        this.handleUserNameValidation() &&
                                                        !userNicknameInUse
                                                            ? ""
                                                            : "danger"
                                                    }
                                                    className={
                                                        styles.validationLabel
                                                    }
                                                    customDangerLabel={
                                                        !userNicknameInUse
                                                            ? `На ${4 -
                                                                  userNameInputValue.length} символа короче`
                                                            : "псевдоним уже используется"
                                                    }
                                                />
                                            ) : null}
                                        </div>
                                        <input
                                            maxLength="25"
                                            defaultValue={userNameInputValue}
                                            className={cx(
                                                styles.input,
                                                styles.inputCustom
                                            )}
                                            onChange={e =>
                                                this.setState({
                                                    userNameInputValue:
                                                        e.target.value,
                                                    userNicknameInUse: false
                                                })
                                            }
                                            placeholder="Пример: jackie27"
                                        />
                                    </div>
                                    <div className={styles.borderLine} />
                                    <div
                                        className={cx(
                                            styles.generalRateFormContainer,
                                            activeSection === "recommendation"
                                                ? styles.activeSection
                                                : ""
                                        )}
                                        onClick={() =>
                                            this.setState({
                                                activeSection: "recommendation"
                                            })
                                        }
                                    >
                                        <div className={styles.titleWrapper}>
                                            <div className={styles.side}>
                                                <div
                                                    className={
                                                        styles.sectionTitle
                                                    }
                                                >
                                                    Вы бы рекомендовали этот
                                                    продукт друзьям?
                                                </div>
                                            </div>
                                            <div
                                                className={cx(
                                                    styles.side,
                                                    styles.rightSide
                                                )}
                                            >
                                                <div>
                                                    <button
                                                        onClick={e => {
                                                            e.preventDefault();
                                                            this.setState({
                                                                recommendationInputValue:
                                                                    "yes"
                                                            });
                                                        }}
                                                        className={cx(
                                                            styles.recommendationButton,
                                                            styles.yesRecommendationButton,
                                                            recommendationInputValue ===
                                                                "yes"
                                                                ? styles.recommendationButtonActive
                                                                : null
                                                        )}
                                                    >
                                                        Да
                                                    </button>
                                                    <button
                                                        onClick={e => {
                                                            e.preventDefault();
                                                            this.setState({
                                                                recommendationInputValue:
                                                                    "no"
                                                            });
                                                        }}
                                                        className={cx(
                                                            styles.recommendationButton,
                                                            styles.noRecommendationButton,
                                                            recommendationInputValue ===
                                                                "no"
                                                                ? styles.recommendationButtonActive
                                                                : null
                                                        )}
                                                    >
                                                        Нет
                                                    </button>
                                                </div>

                                                {recommendationInputValue !==
                                                null ? (
                                                    <BVValidationLabel />
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>

                                    <div className={styles.borderLine} />
                                    <div
                                        className={cx(
                                            styles.generalRateFormContainer,
                                            activeSection === "age"
                                                ? styles.activeSection
                                                : ""
                                        )}
                                        onClick={() =>
                                            this.setState({
                                                activeSection: "age"
                                            })
                                        }
                                    >
                                        <div className={styles.sectionWrapper}>
                                            <div className={styles.side}>
                                                <div
                                                    className={
                                                        styles.sectionTitle
                                                    }
                                                >
                                                    Сколько вам лет?
                                                </div>
                                            </div>
                                            <div
                                                className={cx(
                                                    styles.side,
                                                    styles.rightSide
                                                )}
                                            >
                                                <select
                                                    className={styles.input}
                                                    onChange={e =>
                                                        this.setState({
                                                            ageSelectValue:
                                                                e.target.value
                                                        })
                                                    }
                                                    defaultValue={
                                                        ageSelectValue
                                                    }
                                                >
                                                    <option value="invalid">
                                                        Выберите
                                                    </option>
                                                    <option value="17orUnder">
                                                        17 и младше
                                                    </option>
                                                    <option value="18to24">
                                                        От 18 до 24
                                                    </option>
                                                    <option value="25to34">
                                                        От 25 до 34
                                                    </option>
                                                    <option value="35to44">
                                                        От 35 до 44
                                                    </option>
                                                    <option value="45to54">
                                                        От 45 до 54
                                                    </option>
                                                    <option value="55to64">
                                                        От 55 до 64
                                                    </option>
                                                    <option value="65orOver">
                                                        65 и старше
                                                    </option>
                                                </select>
                                                {ageSelectValue !== null ? (
                                                    <BVValidationLabel
                                                        className={
                                                            styles.validationLabel
                                                        }
                                                        type={
                                                            this.handleAgeSelectValidation()
                                                                ? ""
                                                                : "danger"
                                                        }
                                                    />
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={styles.borderLine} />
                                    <div
                                        className={cx(
                                            styles.generalRateFormContainer,
                                            activeSection === "gender"
                                                ? styles.activeSection
                                                : ""
                                        )}
                                        onClick={() =>
                                            this.setState({
                                                activeSection: "gender"
                                            })
                                        }
                                    >
                                        <div className={styles.sectionWrapper}>
                                            <div className={styles.side}>
                                                <div
                                                    className={
                                                        styles.sectionTitle
                                                    }
                                                >
                                                    Каков ваш пол?
                                                </div>
                                            </div>
                                            <div
                                                className={cx(
                                                    styles.side,
                                                    styles.rightSide
                                                )}
                                            >
                                                <select
                                                    className={styles.input}
                                                    onChange={e =>
                                                        this.setState({
                                                            genderSelectValue:
                                                                e.target.value
                                                        })
                                                    }
                                                    defaultValue={
                                                        genderSelectValue
                                                    }
                                                >
                                                    <option value="">
                                                        Выберите
                                                    </option>
                                                    <option value="Male">
                                                        Мужской
                                                    </option>
                                                    <option value="Female">
                                                        Женский
                                                    </option>
                                                </select>
                                                {genderSelectValue !== null ? (
                                                    <BVValidationLabel
                                                        className={
                                                            styles.validationLabel
                                                        }
                                                    />
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={styles.borderLine} />
                                    <div
                                        className={cx(
                                            styles.generalRateFormContainer,
                                            activeSection === "productQuality"
                                                ? styles.activeSection
                                                : ""
                                        )}
                                        onClick={() =>
                                            this.setState({
                                                activeSection: "productQuality"
                                            })
                                        }
                                    >
                                        <div className={styles.sectionWrapper}>
                                            <div
                                                className={cx(
                                                    styles.sectionTitle,
                                                    styles.side
                                                )}
                                            >
                                                Как бы вы оценили качество этого
                                                товара?
                                            </div>
                                            <div
                                                className={cx(
                                                    styles.side,
                                                    styles.rightSide
                                                )}
                                            >
                                                <BVRatingContainer
                                                    selectedStar={
                                                        productQualityInputValue
                                                    }
                                                    className={
                                                        styles.ratingWrapper
                                                    }
                                                    onSelect={value =>
                                                        this.setState({
                                                            productQualityInputValue: value
                                                        })
                                                    }
                                                />
                                                {productQualityInputValue !==
                                                null ? (
                                                    <BVValidationLabel
                                                        className={
                                                            styles.validationLabel
                                                        }
                                                    />
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div />
                                    <div className={styles.borderLine} />
                                    <div
                                        className={cx(
                                            styles.generalRateFormContainer,
                                            activeSection === "productValue"
                                                ? styles.activeSection
                                                : ""
                                        )}
                                        onClick={() =>
                                            this.setState({
                                                activeSection: "productValue"
                                            })
                                        }
                                    >
                                        <div className={styles.sectionWrapper}>
                                            <div
                                                className={cx(
                                                    styles.sectionTitle,
                                                    styles.side
                                                )}
                                            >
                                                Как бы вы оценили ценность
                                                данного товара?
                                            </div>
                                            <div
                                                className={cx(
                                                    styles.side,
                                                    styles.rightSide
                                                )}
                                            >
                                                <BVRatingContainer
                                                    selectedStar={
                                                        productValueInputValue
                                                    }
                                                    className={
                                                        styles.ratingWrapper
                                                    }
                                                    onSelect={value =>
                                                        this.setState({
                                                            productValueInputValue: value
                                                        })
                                                    }
                                                />
                                                {productValueInputValue !==
                                                null ? (
                                                    <BVValidationLabel
                                                        className={
                                                            styles.validationLabel
                                                        }
                                                    />
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={styles.borderLine} />
                                    <div
                                        className={
                                            styles.generalRateFormContainer
                                        }
                                    >
                                        <div className={styles.sectionWrapper}>
                                            <div
                                                className={cx(
                                                    styles.side,
                                                    styles.terms
                                                )}
                                            >
                                                <input
                                                    type="checkbox"
                                                    name="terms"
                                                    className={
                                                        styles.termsCheckbox
                                                    }
                                                    defaultChecked={
                                                        termsCheckboxValue ===
                                                        null
                                                            ? false
                                                            : termsCheckboxValue
                                                    }
                                                    onChange={e => {
                                                        this.setState({
                                                            termsCheckboxValue:
                                                                e.target.checked
                                                        });
                                                    }}
                                                />
                                                <span>Я принимаю </span>
                                                <a
                                                    href="#"
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        this.setState({
                                                            activeView: "terms"
                                                        });
                                                    }}
                                                    className={styles.link}
                                                >
                                                    условия
                                                </a>
                                            </div>
                                            <div
                                                className={cx(
                                                    styles.side,
                                                    styles.rightSide,
                                                    styles.termsValidationLabel
                                                )}
                                            >
                                                {termsCheckboxValue !== null ? (
                                                    <BVValidationLabel
                                                        type={
                                                            this.handleTermsCheckboxValidation()
                                                                ? ""
                                                                : "danger"
                                                        }
                                                    />
                                                ) : null}
                                            </div>
                                        </div>

                                        <p className={styles.footerStatement}>
                                            Вы можете получать электронные
                                            письма, связанные с данной заявкой.
                                            Все электронные письма будут
                                            содержать ссылку, по которой вы
                                            сможете отписать от последующих
                                            рассылок.
                                        </p>
                                        <button
                                            className={styles.submitButton}
                                            onClick={e => this.handleSubmit(e)}
                                        >
                                            Опубликовать обзор
                                        </button>
                                    </div>
                                </div>
                            </form>
                        ) : null}
                        {activeView === "terms" ? (
                            <BVTerms
                                onRequestClose={() =>
                                    this.setState({
                                        activeView: "form"
                                    })
                                }
                            />
                        ) : null}
                        {activeView === "success" ? <BVSuccess /> : null}
                        {activeView === "reject" ? <BVReject /> : null}
                        {activeView === "error" ? <BVError /> : null}
                    </React.Fragment>
                )}
            />
        );
    }
}

BVRatingForm.propTypes = {
    productId: PropTypes.string.isRequired
};